import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WaiverBuilderService } from './waiver-builder.service';

@Component({
  selector: 'app-waiver-sign-redirect',
  template: `
    <div style="display:flex;align-items:center;justify-content:center;min-height:100vh;color:#6c757d;">
      <div style="text-align:center;" *ngIf="!error">
        <i class="fas fa-spinner fa-spin" style="font-size:2rem;margin-bottom:1rem;"></i>
        <p>Redirecting to waiver...</p>
      </div>
      <div style="text-align:center;" *ngIf="error">
        <i class="fas fa-exclamation-triangle" style="font-size:2rem;margin-bottom:1rem;color:#ffc107;"></i>
        <h4 style="color:#495057;">Invalid Link</h4>
        <p>This waiver link is invalid or has expired.</p>
      </div>
    </div>
  `
})
export class WaiverSignRedirectComponent implements OnInit {

  protected error = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private waiverBuilderService: WaiverBuilderService,
  ) {}

  ngOnInit(): void {
    const encoded = this.route.snapshot.paramMap.get('payload');

    if (!encoded) {
      this.error = true;
      return;
    }

    let decoded: { waiverId: string; name?: string; email?: string; phone?: string } | null;
    try {
      decoded = this.waiverBuilderService.decodeShortLink(encoded);
    } catch (err) {
      console.error('Failed to decode waiver short link:', err);
      this.error = true;
      return;
    }

    if (!decoded || !decoded.waiverId) {
      this.error = true;
      return;
    }

    const queryParams: { [key: string]: string } = {};
    if (decoded.name) queryParams['name'] = decoded.name;
    if (decoded.email) queryParams['email'] = decoded.email;
    if (decoded.phone) queryParams['phone'] = decoded.phone;

    this.router.navigate(['/sign-waiver', decoded.waiverId], { queryParams, replaceUrl: true })
      .catch(err => {
        console.error('Failed to navigate to waiver signing page:', err);
        this.error = true;
      });
  }
}
